import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import { makeStyles } from './ThemeContext';

export interface TextProps extends RNTextProps {
  /** Renders the etched grey-on-white look used for disabled labels. */
  disabled?: boolean;
  bold?: boolean;
}

/** All chrome text. Defaults to the theme's UI face so nothing drifts. */
export function Text({ style, disabled, bold, ...rest }: TextProps) {
  const styles = useStyles();
  return (
    <RNText
      style={[styles.base, bold && styles.bold, disabled && styles.disabled, style]}
      {...rest}
    />
  );
}

const useStyles = makeStyles((t) => ({
  base: {
    fontFamily: t.fonts.ui,
    fontSize: t.fontSizes.ui,
    color: t.colors.windowText,
    // Bitmap-era text had no antialiased line padding; keep leading tight.
    lineHeight: t.fontSizes.ui + 4,
  },
  bold: { fontWeight: 'bold' as const },
  disabled: { color: t.colors.disabledText },
}));
